<header>
  <div
    class="minimize-icon minimize-all"
    [ngClass]="{ 'rotate-icon': numShowsExpanded > 0 }"
    (click)="expandAllShowsToggle()"
  >
    <svg
      width="10"
      height="10"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.50342 11L6.50342 6L1.50342 1"
        stroke="#2DBBFC"
        stroke-width="1.5"
      />
    </svg>
  </div>
  <div class="playout" *ngIf="gridColumns.playout">PLAYOUT</div>
  <div class="name" *ngIf="gridColumns.itemName">NAME</div>
  <div class="origin-filename" *ngIf="gridColumns.origin">ORIGIN</div>
  <div class="media-id" *ngIf="gridColumns.mediaId">MEDIA ID</div>
  <div class="comments" *ngIf="gridColumns.comments">COMMENTS</div>
  <div class="origin-time-start" *ngIf="gridColumns.originItemStart">
    ORIGIN START
  </div>
  <div class="time-start" *ngIf="gridColumns.itemStart">START</div>
  <div class="time-end" *ngIf="gridColumns.itemEnd">END</div>
  <div class="duration" *ngIf="gridColumns.itemDuration">DURATION</div>
  <div
    class="duration"
    *ngIf="
      tenantSettings &&
      tenantSettings.UseMediaStartTimestampInScheduler &&
      gridColumns.vitsSom
    "
  >
    VITC-SOM
  </div>
  <div class="duration" *ngIf="gridColumns.itemSom">SOM</div>
  <div class="sec-events" *ngIf="gridColumns.secEvents">SEC EVENTS</div>
</header>
<ng-content></ng-content>
<div
  [ngClass]="{ 'calendar-list-container': true, dragging: duringDrag }"
  #listviewScrollableContainer
>
  <section
    *ngIf="hasEmptyAtBegin()"
    #empty
    (drop)="onDrop($event, null, empty, true)"
    [ngClass]="{
      'before-time': true,
      capsul: emptyDragIndex === -1,
      'disable-pointer-events': emptyDragIndex === -1,
      hover: emptyDragIndex === -1,
    }"
    (dragenter)="onEmptyDragEnter(empty, -1)"
    (dragover)="onDragOver($event, -1)"
    (dragleave)="onEmptyDragLeave(empty, -1)"
  >
    <div class="minimize-icon"></div>
    <div class="playout empty-playout" *ngIf="gridColumns.playout">
      {{ emptySlotText(-1) }}
    </div>
    <div class="name" *ngIf="gridColumns.itemName"></div>
    <div class="origin-filename" *ngIf="gridColumns.origin"></div>
    <div class="media-id" *ngIf="gridColumns.mediaId"></div>
    <div class="comments" *ngIf="gridColumns.comments"></div>
    <div class="origin-time-start" *ngIf="gridColumns.originItemStart"></div>
    <div class="time-start empty-playout" *ngIf="gridColumns.itemStart">
      {{ !!channelFramerate ? "00:00:00.00" : "00:00:00.000" }}
    </div>
    <div class="time-end empty-playout" *ngIf="gridColumns.itemEnd">
      {{ calculateEmptyEndTime(-1) }}
    </div>
    <div class="duration empty-playout" *ngIf="gridColumns.itemDuration">
      <label>{{ formatTime(calculateEmptyDuration(-1)) }}</label>
    </div>
    <div
      class="duration empty-playout"
      *ngIf="
        tenantSettings &&
        tenantSettings.UseMediaStartTimestampInScheduler &&
        gridColumns.vitsSom
      "
    ></div>
    <div class="duration empty-playout" *ngIf="gridColumns.itemSom"></div>
    <div class="sec-events" *ngIf="gridColumns.secEvents"></div>
  </section>
  <virtual-scroller
    [ngStyle]="{ height: '33vh' }"
    [bufferAmount]="10"
    [checkResizeInterval]="0"
    #scroll
    [items]="shows"
    [parentScroll]="listviewScrollableContainer"
  >
    <section
      class="media-section"
      *ngFor="
        let show of scroll.viewPortItems;
        trackBy: trackByShowAndEmptyFn.bind(this)
      "
      (dragenter)="newSecEventsDragEnter(show.order)"
      [ngStyle]="{
        backgroundColor:
          isLongMedia(show.order) && tenantSettings.LongShowColorHex,
      }"
      (drop)="
        show.expanded &&
          onAddSecEventDrop($event, show.id, show.addNewSecEventVisible);
        show.isHovering = false
      "
      (click)="
        copyShowsViewModel.showClickedEventHandler(show, this.shows, $event)
      "
      (dragleave)="onAddSecEventDragLeave(show.order); show.isHovering = false"
    >
      <section
        class="video-section"
        #dragShow
        (dblclick)="onClickShow(show)"
        [ngClass]="{
          'time-passed': isTimePassed(show.order, false),
          'push-mark': hoverShowIndex === show.order,
          highlight: foundInSearchResults(show.id),
          'disable-pointer-events': hoverShowIndex === show.order,
          'contract-show': isContract(show),
          'live-show': isLive(show),
          'broadcast-show': isBroadcastShow(show),
          'layout-show': isLayoutShow(show),
          'expanded-background-color': show.expanded,
          'show-hover-border':
            show.addSecEventHovering === true && !show.expanded,
          'show-selected': show.selected,
          'show-expanded-hover-border':
            show.isHovering && show.expanded && !show.addNewSecEventVisible,
        }"
        [ngStyle]="generateShowSectionStyle(show)"
        [contextMenu]="basicMenu"
        [contextMenuValue]="show"
        (drop)="onDrop($event, show, null, false)"
        draggable="true"
        (dragenter)="onShowDragEnter(show.order)"
        (dragover)="onDragOver($event, show.order)"
        (dragstart)="onDragStart($event, show.order)"
        (dragleave)="onShowDragLeave(show.order)"
      >
        <div
          class="current-time-line"
          *ngIf="showCurrentTimeIndicator"
          [ngStyle]="{
            display: shouldShowIndicatorLine(show) ? 'block' : 'none',
          }"
        ></div>

        <div
          class="minimize-icon"
          [ngClass]="{ 'rotate-icon': show.expanded }"
          (click)="
            show.expanded = !show.expanded;
            updateNumShowsExpandedProperty(show.expanded)
          "
        >
          <ng-template
            *ngIf="show.isAnchored; then anchorIcon; else arrowIcon"
          ></ng-template>
          <ng-template #arrowIcon>
            <svg
              width="10"
              height="10"
              viewBox="0 0 8 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.50342 11L6.50342 6L1.50342 1"
                stroke="#2DBBFC"
                stroke-width="1.5"
              />
            </svg>
          </ng-template>
          <ng-template #anchorIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="10"
              viewBox="0 -960 960 960"
              width="10"
              class="anchor"
            >
              <path
                fill="#2DBBFC"
                d="M480-80q-61 0-125-22t-116-60q-52-38-85.5-89T120-360v-120l160 120-62 62q29 51 92 88t130 47v-357H320v-80h120v-47q-35-13-57.5-43.5T360-760q0-50 35-85t85-35q50 0 85 35t35 85q0 39-22.5 69.5T520-647v47h120v80H520v357q67-10 130-47t92-88l-62-62 160-120v120q0 58-33.5 109T721-162q-52 38-116 60T480-80Zm0-640q17 0 28.5-11.5T520-760q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760q0 17 11.5 28.5T480-720Z"
              />
            </svg>
          </ng-template>
        </div>

        <div class="playout-media" *ngIf="gridColumns.playout">
          <evrideo-layout-icon
            *ngIf="isLayoutShow(show)"
            [strokeColor]="'white'"
          ></evrideo-layout-icon>
          <div
            class="playout-background"
            [ngStyle]="{ 'background-image': 'url(' + show.thumbnailUrl + ')' }"
          ></div>
        </div>
        <div
          class="name"
          [title]="formatName(show)"
          [innerHTML]="formatName(show)"
          *ngIf="gridColumns.itemName"
        ></div>
        <div
          class="origin-filename"
          [title]="show.OriginMetadata?.origin"
          *ngIf="gridColumns.origin"
        >
          {{ show.OriginMetadata?.origin }}
        </div>
        <div class="media-id" *ngIf="gridColumns.mediaId">
          {{ show.customId }}
        </div>
        <div class="comments" *ngIf="gridColumns.comments">
          <div
            contenteditable="true"
            [attr.data-placeholder]="'add comment'"
            [innerText]="show.comment || ''"
            (click)="
              $any($event.target).style.height = null;
              $any($event.target).style.width = null
            "
            (blur)="editCommentExit($event, show)"
          ></div>
        </div>
        <div class="origin-time-start" *ngIf="gridColumns.originItemStart">
          <span [attr.contenteditable]="false">{{
            formatTextTime(show.OriginMetadata?.OriginStartTime)
          }}</span>
        </div>
        <div
          class="time-start"
          [class.editable-time]="show.isAnchored == false"
          *ngIf="gridColumns.itemStart"
        >
          <span
            #startTime
            [attr.contenteditable]="false"
            (keypress)="onStartTimeKeypress($event, show, startTime)"
            (blur)="editStartTimeExit($event, show, startTime)"
            (click)="onContentEditableClick($event, show, startTime)"
            >{{ formatTime(show.startTime) }}</span
          >
        </div>

        <div
          class="time-end"
          [class.editable-time]="show.isAnchored == false"
          *ngIf="gridColumns.itemEnd"
        >
          <span
            #endTime
            [attr.contenteditable]="false"
            (keypress)="onEndTimeKeypress($event, show, endTime)"
            (blur)="editEndTimeExit($event, show, endTime)"
            (click)="onContentEditableClick($event, show, endTime)"
            >{{ formatTime(show.endTime) }}</span
          >
        </div>
        <div
          class="duration"
          [ngClass]="{
            'editable-time':
              !isAtTime(show.order, false) && show.isAnchored == false,
          }"
          *ngIf="gridColumns.itemDuration"
        >
          <span
            #duration
            [ngClass]="{
              'current-remaining-duration':
                isAtTime(show.order, false) && !duringSkipToShow(),
            }"
            [attr.contenteditable]="false"
            (keypress)="onDurationKeypress($event, show, duration)"
            (blur)="
              !isAtTime(show.order, false) &&
                editDurationExit($event, show, duration)
            "
            (click)="
              !isAtTime(show.order, false) &&
                onContentEditableClick($event, show, duration)
            "
            >{{ formatDuration(calculateShowRemainingTime(show)) }}</span
          >
        </div>

        <div
          class="duration"
          [class.editable-time]="show.isAnchored == false"
          *ngIf="
            tenantSettings &&
            tenantSettings.UseMediaStartTimestampInScheduler &&
            gridColumns.vitsSom
          "
        >
          <span #vitc [attr.contenteditable]="false">{{
            formatDuration(show.som, show.mediaStartTimestampMs)
          }}</span>
        </div>

        <div
          class="duration"
          [class.editable-time]="show.isAnchored == false"
          *ngIf="gridColumns.itemSom"
        >
          <span
            #som
            [attr.contenteditable]="false"
            (keypress)="onSomKeypress($event, show, som)"
            (blur)="
              !isAtTime(show.order, false) && editSomExit($event, show, som)
            "
            (click)="
              !isBroadcastShow(show) &&
                !isAtTime(show.order, false) &&
                onContentEditableClick($event, show, som)
            "
            >{{ formatDuration(show.som) }}</span
          >
        </div>

        <div class="sec-events" *ngIf="gridColumns.secEvents">
          <div *ngIf="_isSecEventsLoading">Loading...</div>
          <div
            *ngIf="_isSecEventsLoading === false"
            class="sec-event-indicator-icons"
          >
            <span
              class="sec-event-icon"
              [ngClass]="{
                'sec-event-inactive': !secEventTypeExists(
                  show.secEvents,
                  secEventType.Audio
                ),
              }"
              inlineSVG="/assets/icons/audio-icon.svg"
            ></span>
            <span
              class="sec-event-icon"
              [ngClass]="{
                'sec-event-inactive': !secEventTypeExists(
                  show.secEvents,
                  secEventType.Subtitles
                ),
              }"
              inlineSVG="/assets/icons/subtitles-icon.svg"
            ></span>
            <span
              class="sec-event-icon"
              [ngClass]="{
                'sec-event-inactive': !secEventTypeExists(
                  show.secEvents,
                  secEventType.ClosedCaptions
                ),
              }"
              inlineSVG="/assets/icons/closed-captions-icon.svg"
            ></span>
            <span
              class="sec-event-icon"
              [ngClass]="{
                'sec-event-inactive': !secEventTypeExists(
                  show.secEvents,
                  secEventType.Autopilot
                ),
              }"
              inlineSVG="/assets/icons/autopilot-icon.svg"
            ></span>
            <span
              class="sec-event-icon"
              [ngClass]="{
                'sec-event-inactive': !secEventTypeExists(
                  show.secEvents,
                  secEventType.Graphics
                ),
              }"
              inlineSVG="/assets/icons/graphics.svg"
            ></span>
            <span
              class="sec-event-icon"
              [ngClass]="{
                'sec-event-inactive': !secEventTypeExists(
                  show.secEvents,
                  secEventType.Cuetone
                ),
              }"
              inlineSVG="/assets/icons/cuetone.svg"
            ></span>
            <span
              class="sec-event-icon"
              [ngClass]="{
                'sec-event-inactive': !secEventTypeExists(
                  show.secEvents,
                  secEventType.SCTE
                ),
              }"
              inlineSVG="/assets/icons/SCTE.svg"
            ></span>
            <span
              class="sec-event-icon"
              [ngClass]="{
                'sec-event-inactive': !secEventTypeExists(
                  show.secEvents,
                  secEventType.FloatingMedia
                ),
              }"
              inlineSVG="/assets/icons/floating-media.svg"
            ></span>
          </div>
        </div>

        <div
          class="long-media-indicator"
          [ngStyle]="{ backgroundColor: tenantSettings.LongShowColorHex }"
          *ngIf="isLongMedia(show.order)"
        >
          Over {{ tenantSettings.LongShowSeconds }} Sec.
        </div>
      </section>

      <evrideo-calendar-expandable
        *ngIf="show.expanded"
        [secEvents]="show.secEvents"
        [show]="show"
        [isShowPlaying]="isShowPlaying(show)"
        [formatDuration]="formatDuration.bind(this)"
        [formatTime]="formatTime.bind(this)"
        [toggleSecEvent]="toggleSecEvent.bind(this)"
        [ngClass]="{
          'minimized-show': !show.expanded,
          'sec-events-hover-border':
            show.isHovering && !show.addNewSecEventVisible,
        }"
      ></evrideo-calendar-expandable>

      <section
        *ngIf="hasEmptyBetweenMovies(show.order)"
        #empty
        (drop)="onDrop($event, show, empty, true)"
        class="before-time"
        [ngClass]="{
          'time-passed': isTimePassed(show.order, true),
          'disable-pointer-events': emptyDragIndex === show.order,
          hover: emptyDragIndex === show.order,
        }"
        (dragenter)="onEmptyDragEnter(empty, show.order)"
        (dragover)="onDragOver($event, show.order)"
        (dragleave)="onEmptyDragLeave(empty, show.order, $event)"
        (click)="$event.stopPropagation()"
      >
        <div class="minimize-icon"></div>
        <div class="playout" *ngIf="gridColumns.playout">
          {{ emptySlotText(show.order, true) }}
        </div>
        <div class="name" *ngIf="gridColumns.itemName"></div>
        <div class="origin-filename" *ngIf="gridColumns.origin"></div>
        <div class="media-id" *ngIf="gridColumns.mediaId"></div>
        <div class="comments" *ngIf="gridColumns.comments"></div>
        <div
          class="origin-time-start"
          *ngIf="gridColumns.originItemStart"
        ></div>
        <div class="time-start" *ngIf="gridColumns.itemStart">
          <label>{{ formatTime(show.endTime) }}</label>
        </div>
        <div class="time-end" *ngIf="gridColumns.itemEnd">
          <label>{{ calculateEmptyEndTime(show.order) }}</label>
        </div>
        <div class="duration" *ngIf="gridColumns.itemDuration">
          <label>{{ formatTime(calculateEmptyDuration(show.order)) }}</label>
        </div>
        <div
          class="duration"
          *ngIf="
            tenantSettings &&
            tenantSettings.UseMediaStartTimestampInScheduler &&
            gridColumns.vitsSom
          "
        ></div>
        <div class="duration" *ngIf="gridColumns.itemSom"></div>
        <div class="sec-events" *ngIf="gridColumns.secEvents"></div>
      </section>
    </section>
  </virtual-scroller>
</div>

<div
  class="empty-space-outside"
  (drop)="onDrop($event, shows[shows.length - 1], null, true)"
  (dragenter)="onEmptyDragEnter($event, shows.length)"
  (dragover)="onDragOver($event, shows.length - 1)"
  (dragleave)="onEmptyDragLeave($event, shows.length)"
>
  <div *ngIf="isLoading" class="loader-bg-panel">
    <img src="/assets/loader3.svg" />
    <span>Loading Content</span>
  </div>
  <context-menu [menuClass]="'absolute-positioned'">
    <ng-template contextMenuItem let-item (execute)="removeShow($event.value)">
      Remove from calendar
    </ng-template>
    <ng-template
      contextMenuItem
      let-item
      [visible]="isItemSelected.bind(this)"
      (execute)="copyShowsViewModel.copySelectedShows(shows)"
      *ngIf="copyShowsViewModel.readyToCopy"
    >
      Copy Selected Shows
    </ng-template>
    <ng-template
      contextMenuItem
      (execute)="
        copyShowsViewModel.paste(
          $event.value.startTime,
          _currentChannel,
          isBlock
        )
      "
      *ngIf="copyShowsViewModel.readyToPaste"
    >
      Paste Before
    </ng-template>
    <ng-template
      contextMenuItem
      (execute)="
        copyShowsViewModel.paste($event.value.endTime, _currentChannel, isBlock)
      "
      *ngIf="copyShowsViewModel.readyToPaste"
    >
      Paste After
    </ng-template>
    <ng-template
      contextMenuItem
      (execute)="
        copyShowsViewModel.contextMenuLoopFillItemClicked(
          $event.value,
          _currentChannel,
          isBlock
        )
      "
      *ngIf="copyShowsViewModel.readyToPaste"
    >
      Loop Paste...
    </ng-template>
    <ng-template
      *ngFor="let script of getUserDynamicScripts()"
      contextMenuItem
      (execute)="onDynamicScriptClick($event.value, script)"
      [visible]="!copyShowsViewModel.isMultiplySelection"
    >
      {{ script.displayName }}
    </ng-template>
    <ng-template
      contextMenuItem
      (execute)="closeGap($event.value)"
      [visible]="!copyShowsViewModel.isMultiplySelection"
    >
      Close gap
    </ng-template>
    <ng-template
      contextMenuItem
      (execute)="openReplaceShowModal($event.value)"
      [visible]="isReplaceShowMenuVisible.bind(this)"
    >
      Replace show
    </ng-template>
    <ng-template
      contextMenuItem
      (execute)="openRenameModal($event.value)"
      [visible]="!copyShowsViewModel.isMultiplySelection"
    >
      Rename show
    </ng-template>
    <ng-template
      contextMenuItem
      let-item
      [visible]="isChooseSegmentMenuVisible.bind(this)"
      (execute)="chooseSegmentClickedEventHandler($event.value)"
    >
      Choose Segment
    </ng-template>
    <ng-template
      contextMenuItem
      (execute)="openChannelFuturePreview($event.value)"
      [visible]="!copyShowsViewModel.isMultiplySelection"
    >
      Preview
    </ng-template>
    <ng-template contextMenuItem (execute)="createBlockClicked($event.value)">
      Create Block
    </ng-template>
    <ng-template
      contextMenuItem
      let-item
      *ngIf="!copyShowsViewModel.isMultiplySelection"
      (execute)="changeAnchorState($event.value)"
    >
      {{ showAnchorMenuItemText(item) }}
    </ng-template>
  </context-menu>
</div>
